import { hasValue } from '../helpers';
import { isContactReceiver } from '../typeguards';
export class ReceiverService {
    activeReceiver;
    setActive(activeReceiver) {
        this.activeReceiver = activeReceiver;
    }
    getActive() {
        return this.activeReceiver;
    }
    isConversationActive(conversation) {
        if (!this.activeReceiver) {
            return false;
        }
        return this.compare(conversation, this.activeReceiver);
    }
    compare(a, b) {
        return a !== undefined
            && b !== undefined
            && a.type === b.type
            && a.id === b.id;
    }
    isBusinessContact(receiver) {
        return isContactReceiver(receiver)
            && receiver.id.substr(0, 1) === '*';
    }
    isBlocked(receiver) {
        if (!hasValue(receiver)) {
            return false;
        }
        if (isContactReceiver(receiver) && hasValue(receiver.isBlocked)) {
            return receiver.isBlocked;
        }
        else {
            return false;
        }
    }
}
